import { render } from "./ServicesProvidersImport.vue?vue&type=template&id=eccf3100"
import script from "./ServicesProvidersImport.vue?vue&type=script&lang=js"
export * from "./ServicesProvidersImport.vue?vue&type=script&lang=js"

import "./ServicesProvidersImport.vue?vue&type=style&index=0&id=eccf3100&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__